import React from 'react'
import styled, { css } from 'styled-components'
import { media } from '../styles/media'

export const Card = styled.div`
  background:${({ bgColor }) => bgColor};
  width:343px;
  margin:0px auto 16px;
  border-radius:16px;
  display:flex;
  flex-flow:column nowrap;
  align-items:center;
  justify-content:center;
  padding:0 32px 32px;
  ${() => media.tablet(css`
    height:390px;
  `)}
  p{
    font-weight:900;
    text-align:center;
    width:100%;
    margin-bottom:16px;
  }
`
export const StyledLogo = styled.div`
.leftImg,.rightImg,.rightImg2,.rightImg3{
  display:none;
}
  width:100%;
  display:flex;
  flex-flow:column nowrap;
  align-items:center;
  justify-content:center;
  .gatsby-image-wrapper{
    margin:32px 0;
    width:200px;
  }
  p{
    width:100%;
    text-align:center;
    font-weight:500;
    margin-bottom:32px;
  }
  ${() => media.pc(css`
    height:50vh!important;
  `)}
  ${() => media.tablet(css`
    position:relative;
    height:40vh;
    .leftImg,.rightImg,.rightImg2,.rightImg3{
      position:absolute;
      display:inline-block;
    }
    .leftImg{
      left:15%;
      height:130px;
      width:180px;
      img{
        height:130px;
        width:auto;
      }
    }
    .rightImg{
      right:15%;
      height:180px;
      width:150px;
      display:flex;
      flex-flow:row nowrap;
      align-items:center;
      justify-content:center;
      img{
        height:180px;
        width:auto;
      }
    }
    .rightImg2{
      right:15%;
      height:180px;
      width:200px;
      display:flex;
      flex-flow:row nowrap;
      align-items:center;
      justify-content:center;
      img{
        height:auto;
        width:180px;
        margin-top:30px;
      }
    }
    .rightImg3{
      right:15%;
      height:130px;
      width:150px;
      display:flex;
      flex-flow:row nowrap;
      align-items:center;
      justify-content:center;
      img{
        height:130px;
        width:auto;
      }
    }
  `)}
`
